import { render, staticRenderFns } from "./water_meter.vue?vue&type=template&id=81ddb81c&scoped=true&"
import script from "./water_meter.vue?vue&type=script&lang=js&"
export * from "./water_meter.vue?vue&type=script&lang=js&"
import style0 from "./water_meter.vue?vue&type=style&index=0&id=81ddb81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ddb81c",
  null
  
)

export default component.exports